	<template>
	<v-container fluid :class="classContainer">
		<v-toolbar class="elevation-1">
			<v-list-tile class="v-list-tile-pl0">
				<v-list-tile-avatar v-if="$route.meta.pageTitle.avatar">
					<v-icon class="white--text" :class="$route.meta.pageTitle.avatar.color">{{$route.meta.pageTitle.avatar.icon}}</v-icon>
				</v-list-tile-avatar>
				<v-list-tile-content>
					<v-list-tile-title class="title">{{$route.meta.pageTitle.title}}</v-list-tile-title>
					<v-list-tile-sub-title>{{$route.meta.pageTitle.subTitle}}</v-list-tile-sub-title>
				</v-list-tile-content>
			</v-list-tile>
			<v-spacer></v-spacer>
			<slot name="actions"></slot>
		</v-toolbar>
	</v-container>
</template>

<script>
export default {
	props: {
		classContainer: {
			type: String,
			default: ''
		}
	},
    data: () => ({
	})
}
</script>